"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControlRegistry__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "rootRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "manager",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "InitializedManager",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "adminRole",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "InitializedRole",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "manager",
                type: "address",
            },
        ],
        name: "initializeManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "adminRole",
                type: "bytes32",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "initializeRoleAndGrantToSender",
        outputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class AccessControlRegistry__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.AccessControlRegistry__factory = AccessControlRegistry__factory;
//# sourceMappingURL=AccessControlRegistry__factory.js.map